import Fuse from 'fuse.js';
const glossarySections = document.querySelectorAll( '.e-stn--glossary-section' );
if( glossarySections.length > 0 ) {
  const glossaryItems = document.querySelectorAll( '.e-stn--glossary-section p' );
  const noResultsEl = document.querySelector( '.e-stn--glossary-search .no-results-msg' );
  const glossaryData = [];
  glossaryItems.forEach( ( glossaryItem ) => {
    const glossaryTitle = glossaryItem.innerText;
    glossaryData.push( glossaryTitle );
    glossaryItem.addEventListener( 'click', () => {
      const glossaryId = glossaryItem.dataset.glossary;
      localStorage.setItem( 'selectedGlossary', glossaryId );
    } );
  } );
  const options = {
    threshold: 0.3,
  };
  const fuse = new Fuse( glossaryData, options );

  document.getElementById( 'glossary-search' ).addEventListener( 'input', function () {
    const query = this.value;
    const results = fuse.search( query );
    if ( query !== '' ) {
      glossarySections.forEach( ( sec ) => {
        sec.style.display = 'none';
      } );
      glossaryItems.forEach( ( item ) => {
        item.style.display = 'none';
      } );
    } else {
      glossarySections.forEach( ( sec ) => {
        sec.style.display = 'block';
      } );
      glossaryItems.forEach( ( item ) => {
        item.style.display = 'flex';
      } );
    }
    if ( results.length > 0 || query === '' ) {
      noResultsEl.style.display = 'none';
    } else {
      noResultsEl.style.display = 'block';
    }
    results.forEach( ( result ) => {
      const resultInd = result.refIndex;
      glossaryItems[resultInd].closest( '.e-stn--glossary-section' ).style.display = 'block';
      glossaryItems[resultInd].style.display = 'flex';
    } );
  } );
}
